var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"icon is-medium middle is-size-5"},_vm.$listeners),[_c('i',{staticClass:"mdi mdi-plus-circle-outline"})])}
var staticRenderFns = []

export { render, staticRenderFns }